module.exports = __webpack_public_path__ + "static/media/img-emandamento-sanpaolo-jun23-1.a70b0267.jpg";